module.exports = __webpack_public_path__ + "static/media/b-certified.82ed1292.svg";